import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ProfileActions } from "redux-store";

// Listener changing and update online status
const HandleOnlineStatus = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const updateOnlineStatus = hasInternet => () =>
      dispatch(
        ProfileActions.profileSet({
          hasInternet: hasInternet,
        }),
      );

    window.addEventListener("offline", updateOnlineStatus(false));
    window.addEventListener("online", updateOnlineStatus(true));

    return () => {
      window.removeEventListener("offline", updateOnlineStatus(false));
      window.removeEventListener("online", updateOnlineStatus(true));
    };
  }, []);

  return null; // This component doesn't render anything
};

export default HandleOnlineStatus;
